<template>
<m-pageframe
    title="{organization-label}: Inboxes"
>
<v-container
    fluid
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <span slot="append-outer">
            <v-menu 
                bottom 
                offset-y  
                v-if="can_write"
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickCreateNewInbox()"
                >
                    <v-list-item-title>Create New Inbox</v-list-item-title>
                </v-list-item>
            </v-list>
            
            </v-menu> 
        </span>
    </v-text-field>

    <v-checkbox
        label="Show Archived"
        style="margin-top: -15px"
        v-model="show_archived"
        v-on:change="doUpdate"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="10000"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.order_by_index="{ item }">
            <div 
                class="cell_position"
                v-on:click="onClickCellPosition(item)"
            >
                {{item.order_by_index}}
            </div>
        </template>

        
    
        <template v-slot:item.notes="{ item }">
            <div
                v-if="item.forward_to_inbox_label != null"
            >
                <b>Forwards To</b><br/>
                <ul>
                    <li>{{item.forward_to_inbox_label.organization_label}} > {{item.forward_to_inbox_label.internal_label}}</li>
                </ul>
            </div>

            <div
                v-if="item.forward_from_inboxes.length > 0"
            >
                <b>Forwards From</b><br/>
                <ul>
                    <li
                        v-for="(label, index) in item.forward_from_inboxes"
                        :key="'ff'+index"
                    >
                        {{label.organization_label}} > {{label.internal_label}}
                    </li>
                </ul>
            </div>    

        </template>

         <template v-slot:item.is_archived="{ item }">
           <v-simple-checkbox
                :value="item.is_archived"
                disabled
           />
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>View / Edit...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickContactRequests(item)"
                >
                    <v-list-item-title>Contact Requests...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickFormConnect(item)"
                >
                    <v-list-item-title>Website (form) integration...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onMoveUp(item)"
                    :disabled="!can_write"
                >
                    <v-list-item-title>Move Up</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onMoveDown(item)"
                    :disabled="!can_write"
                >
                    <v-list-item-title>Move Down</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickMoveTo(item)"
                    :disabled="!can_write"
                >
                    <v-list-item-title>Move To...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickArchive(item)"
                    :disabled="!can_write || item.forward_from_inboxes.length > 0"
                >
                    <v-list-item-title>{{item.is_archived ? 'Unarchive' : 'Archive'}}</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div
        style="text-align: right; margin-top: 15px;"
        v-if="can_write"
    >
        <v-btn
            class="mx-2" fab dark small color="primary"
            v-on:click="onClickCreateNewInbox"
        >
        <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </div>

    <m-dialog-create-inbox
        ref="dialog-create-inbox"
        v-on:ok="onCreateNewInbox"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            results: [],
            full_text: null,
            show_archived: false,

            headers: [
                { text: 'Position', value: 'order_by_index'},
                { text: 'Internal Label', value: 'internal_label'},
                { text: 'Help With', value: 'help_with'},
                { text: 'Notes', value: 'notes'},
                { text: 'Archived', value: 'is_archived'},
                { text: 'Action', value: 'action' }
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/inboxes',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'full_text' : this.full_text,
                    'is_archived': this.show_archived ? null : false,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'edit-inbox',
                'params' : {
                    'organization_id' : item.organization_id,
                    'inbox_id' : item.inbox_id,
                }
            });
        },

        onClickArchive(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/inboxes/toggle-archived',
            
                'params' : {
                        'inbox_id' : item.inbox_id,
                    },
            
                'on_success': (data) => {
                        this.update();
                    },
            
                'on_error': 'Unable to toggle inbox archived',
            });
        },

        onClickContactRequests(item)
        {
            this.$router.push({
                'name': 'search-inbox-contact-requests',
                'params' : {
                    'organization_id' : item.organization_id,
                    'inbox_id' : item.inbox_id,
                }
            });
        },

        onClickFormConnect(item)
        {
             this.$router.push({
                'name': 'form-connect',
                'params' : {
                    'organization_id' : item.organization_id,
                    'inbox_id' : item.inbox_id,
                }
            })
        },

        onMoveUp(item)
        {
            this.onMove('MOVE-UP', item);
        },

        onMoveDown(item)
        {
            this.onMove('MOVE-DOWN', item);
        },

        onClickMoveTo(item)
        {
            this.$rc.prompt({
                'title' : 'New position: '+item.internal_label,
                'label' : 'Move inbox '+item.internal_label+" from position "+item.order_by_index+" to position (number):",
                'value' : ''+item.order_by_index,
                'after_prompt' : (value) => {
                    let position = parseInt(value);

                    if ( isNaN(position) )
                    {
                        this.$rc.alert("Invalid position", 'New position must be a number.  No changes have been made.');
                        return;
                    }

                    this.moveTo(item, position);
                }
            });
        },

        moveTo(item, position)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/inboxes/move-inbox',
            
                {
                    'inbox_id': item.inbox_id,
                    'position': position,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to move inbox');
                },
            );
        },

        onMove(direction, item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                direction+': /api/v1/inboxes/:inbox_id',
            
                {
                    'inbox_id' : item.inbox_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
        
        onClickCreateNewInbox()
        {
            this.$refs['dialog-create-inbox'].showDialog();
        },

        onCreateNewInbox(params)
        {
            this.$rc.rest(
                'CREATE: /api/v1/inboxes',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'internal_label' : params.internal_label,
                    'help_with' : params.help_with,
                },
            
                (data) => {
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.alert('Error','Unable to create new inbox');
                },
            );
        },

        onClickCellPosition(item)
        {
            this.$rc.prompt({
                'title' : 'Change position',
                'text' : 'Enter the new position for this inbox',
                'label' : 'New position',
                'value' : item.order_by_index,
                'after_prompt' : (value) => {
                   
                    this.$rc.showSpinner();
                    
                    this.$rc.rest(
                        'SET-POSITION: /api/v1/inboxes',
                    
                        {
                            'inbox_id' : item.inbox_id,
                            'set_position' : parseInt(value),
                        },
                    
                        (data) => {
                            this.$rc.hideSpinner();
                            this.doUpdate();
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to set position');
                        },
                    );

                },

                'is_valid' : (value) => {
                    if ( value == null ) return false;
                    if ( isNaN(parseFloat(value)) ) return false;
                    
                    return true;
                }
            });
        },
    },

    computed: {
        can_write() {
            return this.$rc.$state.isOrganizationAdmin();
        }
    },
    
}
</script>

<style lang="scss" scoped>
.cell_position {
    cursor: pointer;
}

.cell_position:hover
{
    text-decoration: underline;
}

</style>